// extracted by mini-css-extract-plugin
module.exports = {"svg":"capitular-module--svg--1dn2Q"};